const CatQuizResults = () => import('../views/CatQuizResults');

const router = [
  {
    name: 'catQuizResults',
    path: '/viewer/cat-quizzes/:page(\\d+)/results',
    component: CatQuizResults,
    props: true,
    meta: {
      requiresAuth: true,
    },
    children: [
    ],
  },
];

export default router;
